import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DeviceDetectorService } from 'ngx-device-detector';

import { AppStateService } from 'src/app/core/services';
import { AppErrorService } from './app-error.service';

@Component({
	selector: 'core-app-error',
	templateUrl: './app-error.component.html'
})
export class AppErrorComponent implements OnInit {
	public status: number;
	public message: string;
	public userText: string;

	constructor(
		public appErrorService: AppErrorService,
		public appStateService: AppStateService,
		private deviceDetectorService: DeviceDetectorService,
		private router: Router
	) {}

	ngOnInit(): void {}

	public onSendReportClick(): void {
		this.appErrorService.sendEmail(this.email());
		location.reload();
	}

	public onIgnoreClick(): void {
		location.reload();
	}

	public onMyProductsClick(): void {
		this.appErrorService.showAppError = false;
		this.router.navigate(['/my-products']);
	}

	private email(): any {
		return {
			To: this.appStateService.csrByClient.Email,
			From: 'portalerror@works24.com',
			Subject: 'Portal Error',
			Body: this.emailBody()
		};
	}

	private emailBody(): string {
		const deviceInfo = this.deviceDetectorService.getDeviceInfo();
		const deviceInfoString = Object.entries(deviceInfo)
			.map(([key, value]) => `${key}: ${value}`)
			.join(', ');
		return (
			`User-Entered Text: \n \n ${this.userText ?? 'No text entered.'} \n \n \n` +
			`Logged-in User: ${this.appStateService.currentUser.UserName} \n \n` +
			`Client: ${this.appStateService.currentClient.Name} \n \n` +
			`Current Url: ${this.router.url} \n \n` +
			`Device Info: ${deviceInfoString}\n \n` +
			`Error: ${this.appErrorService.error.message}`
		);
	}
}
